import { useState, useRef } from "react";
import { useLanguage } from "context/LanguageContext";

const ALLOWED_TYPES = ["image/jpeg", "image/png", "application/pdf"];
const MAX_SIZE_MB = 1;

function FileUpload({ label, onChange, initialFile = null }) {
    const { t } = useLanguage();
    const [file, setFile] = useState(initialFile);
    const [error, setError] = useState("");
    const [dragOver, setDragOver] = useState(false);
    const inputRef = useRef(null);

    function validate(f) {
        if (!ALLOWED_TYPES.includes(f.type)) {
            setError(t.invalidFileType);
            return false;
        }
        if (f.size > MAX_SIZE_MB * 1024 * 1024) {
            setError(t.fileTooLarge);
            return false;
        }
        return true;
    }

    function handleFile(f) {
        setError("");
        if (validate(f)) {
            setFile(f);
            if (onChange) onChange(f);
        }
    }

    function onInputChange(e) {
        if (e.target.files[0]) handleFile(e.target.files[0]);
    }

    function onDrop(e) {
        e.preventDefault();
        setDragOver(false);
        if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
    }

    function removeFile() {
        setFile(null);
        setError("");
        if (inputRef.current) inputRef.current.value = "";
        if (onChange) onChange(null);
    }

    function getIcon(type) {
        if (type === "application/pdf") return "fa-file-pdf-o";
        return "fa-file-image-o";
    }

    function formatSize(bytes) {
        return bytes < 1024 * 1024
            ? `${(bytes / 1024).toFixed(1)} KB`
            : `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    }

    return (
        <div className="form-group">
            {!file ? (
                <div
                    className={`drop-zone${dragOver ? " dragover" : ""}`}
                    onClick={() => inputRef.current.click()}
                    onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                    onDragLeave={() => setDragOver(false)}
                    onDrop={onDrop}
                >
                    <i className="fa fa-cloud-upload" style={{ fontSize: "2rem" }}></i>
                    <p className="mb-0"><b>{label}</b></p>
                    <p className="text-muted" style={{ fontSize: "12px" }}>{t.fileFormatHint}</p>
                    <p style={{ fontSize: "12px", color: "#25826A", marginTop: "4px" }}>
                        {t.clickToBrowse}
                    </p>
                    <input
                        ref={inputRef}
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        onChange={onInputChange}
                    />
                </div>
            ) : (
                <div style={{
                    border: "1px solid #25826A55",
                    borderRadius: "10px",
                    padding: "14px 16px",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "12px",
                    background: "#25826A08"
                }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ fontWeight: 600, fontSize: "13px", color: "#333", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: "-2px", lineHeight: "1" }}>
                            {file.name}
                        </p>
                        <span style={{ fontSize: "11px", color: "#888", lineHeight: "1" }}>{formatSize(file.size)}</span>
                    </div>
                    <button
                        type="button"
                        onClick={removeFile}
                        style={{ background: "none", border: "none", cursor: "pointer", color: "#e74c3c", fontSize: "22px", padding: "0", marginTop: "2px" }}
                        title="Remove"
                    >
                        <i className="fa fa-times-circle"></i>
                    </button>
                </div>
            )}
            {error && <p style={{ color: "#e74c3c", fontSize: "12px", marginTop: "6px" }}>{error}</p>}
        </div>
    );
}

export default FileUpload;
